import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { clsx } from 'clsx';
import { Check } from 'lucide-react';
import { UrgencyBanner } from './UrgencyBanner';
type Offer = 'kit' | 'mega';
const OFFERS = {
  kit: {
    href: 'https://solucionesya.shop/cart/48819516735736:1',
    cta: 'QUIERO EL KIT NEGOCIO DE ORO'
  },
  mega: {
    href: 'https://solucionesya.shop/cart/48819517128952:1',
    cta: 'SÍ, QUIERO EL MEGAPACK COMPLETO'
  }
};
export function FooterCTA() {
  const [selected, setSelected] = useState<Offer>('mega');
  return <div className="border-t border-border bg-[linear-gradient(180deg,transparent_0%,rgba(201,168,76,0.04)_100%)] py-12 text-center sm:py-20" data-id="element-131">
      <div className="mx-auto max-w-[800px] px-6" data-id="element-132">
        <h2 className="mb-3 font-serif text-[clamp(24px,4vw,36px)] font-bold text-white" data-id="element-133">
          No dejes pasar esta oportunidad.
        </h2>
        <p className="mb-8 text-[15px] text-text" data-id="element-134">
          El mercado de joyas y oro en Argentina no para de crecer. El sistema
          que te faltaba ya está acá.
        </p>

        <UrgencyBanner data-id="element-135" />

        <div className="mx-auto flex max-w-[560px] flex-col gap-3" data-id="element-136">
          <CompactOption selected={selected === 'kit'} onSelect={() => setSelected('kit')} label="Kit Negocio de Oro" sub="6 tomos + 3 bonos" price="$19.990" data-id="element-137" />
          <CompactOption selected={selected === 'mega'} onSelect={() => setSelected('mega')} label="⭐ Megapack" sub="8 tomos + 3 bonos" price="$27.990" featured data-id="element-138" />
        </div>

        <div className="mx-auto mt-7 max-w-[480px]" data-id="element-139">
          <a href={OFFERS[selected].href} target="_blank" rel="noopener noreferrer" className="block w-full rounded-md bg-gold p-[18px] text-[15px] font-bold tracking-[0.04em] text-[#111] transition-all duration-200 hover:-translate-y-0.5 hover:bg-gold-light" data-id="element-140">
            {OFFERS[selected].cta}
          </a>
        </div>

        <div className="mt-7 flex flex-wrap items-center justify-center gap-6 text-[12px] tracking-[0.06em] text-muted" data-id="element-141">
          <span data-id="element-142">Pago seguro</span>
          <div className="h-[3px] w-[3px] rounded-full bg-border" data-id="element-143" />
          <span data-id="element-144">Acceso en 5 min</span>
          <div className="h-[3px] w-[3px] rounded-full bg-border" data-id="element-145" />
          <span data-id="element-146">Garantía 7 días</span>
          <div className="h-[3px] w-[3px] rounded-full bg-border" data-id="element-147" />
          <span data-id="element-148">Mercado Pago</span>
        </div>
      </div>
    </div>;
}
type CompactOptionProps = {
  selected: boolean;
  onSelect: () => void;
  label: string;
  sub: string;
  price: string;
  featured?: boolean;
};
function CompactOption({
  selected,
  onSelect,
  label,
  sub,
  price,
  featured
}: CompactOptionProps) {
  return <button type="button" onClick={onSelect} aria-pressed={selected} className={clsx('relative flex w-full items-center gap-4 rounded-xl border bg-card p-4 text-left transition-all duration-300', selected ? 'border-gold shadow-[0_0_24px_rgba(201,168,76,0.18)]' : 'border-border hover:border-gold/40')} data-id="element-149">
      {featured && <div className="absolute -top-2.5 left-4 whitespace-nowrap rounded bg-gold px-2.5 py-0.5 text-[9px] font-bold uppercase tracking-[0.1em] text-[#111]" data-id="element-150">
          Más elegido
        </div>}
      <span className={clsx('flex h-6 w-6 shrink-0 items-center justify-center rounded-full border-2 transition-colors', selected ? 'border-gold bg-gold' : 'border-muted')} data-id="element-151">
        {selected && <motion.span initial={{
        scale: 0
      }} animate={{
        scale: 1
      }} transition={{
        duration: 0.2
      }} data-id="element-152">
            <Check className="h-3.5 w-3.5 text-[#111]" strokeWidth={4} data-id="element-153" />
          </motion.span>}
      </span>
      <div className="min-w-0 flex-1" data-id="element-154">
        <div className="text-[14px] font-semibold text-white" data-id="element-155">{label}</div>
        <div className="text-[11px] text-muted" data-id="element-156">{sub}</div>
      </div>
      <div className="shrink-0 font-serif text-[26px] font-black leading-none text-gold" data-id="element-157">
        {price}
      </div>
    </button>;
}